import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    members: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_MEMBER_SELECT_IDS (store, ids) {
      store.members.selectIds = ids
    },
    REMOVE_MEMBER_SELECT_IDS (store, ids) {
      store.members.selectIds = store.members.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_MEMBER_SELECT_ID (store, id) {
      store.members.selectId = id
    },
    SET_MEMBER_FILTERS (store, filters) {
      store.members.filters = filters
    },
    SET_MEMBER_PAGINATE (store, val) {
      store.members.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getMembers: (store, getters) => {
      return store.members.selectIds.map((id) => {
        return getters['entities/members/find'](id)
      })
    },
    getMembersFilters: (store, getters) => {
      return store.members.filters
    },
    getMembersPaginate: (store, getters) => {
      return store.members.paginate
    },
    getMember: (store, getters) => {
      return getters['entities/members/find'](store.members.selectId) || {}
    }
  },
  actions: {
    /*
    selectMembers
    */
    selectMembers ({commit, dispatch, getters, state}, filters) {
      return dispatch('getMembers', filters)
      .then((response) => {
        commit('SET_MEMBER_FILTERS', filters)
        commit('SET_MEMBER_PAGINATE', response)
        commit('SET_MEMBER_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectMembers
    */
    refreshSelectMembers ({commit, dispatch, getters, state}) {
      return dispatch('selectMembers', getters.getMembersFilters)
    },
    /*
    selectMember
    */
    selectMember ({commit, dispatch, getters, state}, id) {
      return dispatch('getMemberById', id)
      .then((response) => {
        commit('SET_MEMBER_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getMembers
    */
    getMembers ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/members`, {params: filters})
      .then((response) => {
        return dispatch('entities/members/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.members || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getMemberById
    */
    getMemberById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/members/${id}`)
      .then((response) => {
        return dispatch('entities/members/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.members[0]
      })
    },
    /*
    createMember
    */
    createMember ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/members`, data)
      .then((response) => {
        return dispatch('entities/members/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.members[0]
      })
    },
    /*
    updateMember
    */
    updateMember ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/members/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/members/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.members[0]
      })
    },
    /*
    deleteMember
    */
    deleteMember ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/members/${id}`)
      .then((response) => {
        commit('REMOVE_MEMBER_SELECT_IDS', [id])
        dispatch('entities/members/delete', id)
        return {}
      })
    },

    /*
    resendInvite
    */
    resendInvite ({commit, dispatch, getters, state}, id) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/members/${id}/resend-invite`, {})
      .then((response) => {
        return dispatch('entities/members/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.members[0]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Member.js